import { Component, OnInit } from '@angular/core';
import { NgxSpinner } from 'ngx-spinner/lib/ngx-spinner.enum';
import { Toast, ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  getRetailerNotificationsdata: any;
  imageCount=0;
  pdfCount=0;
  vdoCount=0;
  imgLabel: string;
  pdfLabel: string;
  vdoLabel: string;
  /* presentation only: which attachment-type tab is showing */
  activeTab: string = 'img';

  constructor(private auth: AuthService,private ngxService: NgxUiLoaderService,private toastr: ToastrService, ) { }

  ngOnInit(): void {
    this.getRetailerNotifications();
  }
  getRetailerNotifications(){
    this.ngxService.start();
    this.auth.getRetailerNotificationsApi('NOTIFICATION').subscribe((res:any)=>{
      this.ngxService.stop();

      if(res.status_code == 1){
        this.getRetailerNotificationsdata = res.object;
        for(var i=0;i<this.getRetailerNotificationsdata.length;i++){
          if(this.getRetailerNotificationsdata[i].attachurl.includes('.png') || this.getRetailerNotificationsdata[i].attachurl.includes('.jpg') || this.getRetailerNotificationsdata[i].attachurl.includes('.JPEG')){
             this.imageCount= this.imageCount+1;
             this.imgLabel= "Image"+" "+"("+this.imageCount+")";
          }else if(this.getRetailerNotificationsdata[i].attachurl.includes('.pdf') || this.getRetailerNotificationsdata[i].attachurl.includes('.PDF')){
            this.pdfCount= this.pdfCount+1;
            this.pdfLabel= "PDF"+" "+"("+this.pdfCount+")";
        
          }else if(this.getRetailerNotificationsdata[i].attachurl.includes('.mp4')){
            this.vdoCount= this.vdoCount+1;
            this.vdoLabel= "Video"+" "+"("+this.vdoCount+")";
        
          }

        }
        this.toastr.success(res.message);
      

      }else {
        this.getRetailerNotificationsdata = [];

        this.toastr.error(res.error.message);

      }
    },err=>{
      this.ngxService.stop();

    })
  }

  handleTabChange(value){

  }
}
